<template>
  <html>
    <head> </head>
    <body>
      <navbar></navbar>

      <!--img id="header-s" src="https://i.ibb.co/1J2YTy2/Loyalty-hub-header-s.png" /-->

      <div class="title-redeem-l header-banner">
        <img
          class="icon-title"
          src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-icon-point.png"
        />
        <p class="redeem-p">คะเเนนสะสม</p>
        <h1 style="font-weight: 600; letter-spacing: 1.5px;">{{ info.point  | numFormat('0,000,000') }}</h1>
      </div>

      <div class="title-redeem-r font-color" style="padding-top:10px;">
        <a @click="goto('RedeemHistory')"> <p style="text-align:center;">ประวัติการเเลก</p> </a>
      </div>
      <div class="container">
        <div class="row">
          <div class="col">
            <a
              @click="goto('Redeem05', reward._id)"
              class="row bg-white"
              v-for="reward in rewards"
              :key="reward._id"
            >
              <div>
                <img
                  class="img-product-redeem"
                  :src="'https://api.loyaltyhub.me/public/' + reward.image"
                  v-if="reward.image != ''"
                />
                <div class="progress" style="height: 4px">
                  <div
                    class="progress-bar"
                    role="progressbar"
                    :style="
                      'width:' +
                      ((reward.available || reward.quantity) * 100) / reward.quantity +
                      '%'
                    "
                    :aria-valuenow="reward.available || reward.quantity"
                    aria-valuemin="0"
                    :aria-valuemax="reward.quantity"
                  ></div>
                </div>
                <span class="name-product">{{ reward.name }}</span>
                <img
                  class="iconpointproduct"
                  src="/assets/icon/point.svg"
                />
                <br><span class="name-price">{{ reward.point | numFormat('0,000,000') }} คะแนน</span>
                <br><span class="name-time"
                  >เวลาที่เหลือ {{ remainDate(reward.expire_date) }} วัน</span
                >
              </div>
            </a>
          </div>
        </div>

        <!-- <a href="Redeem02" class="row bg-white">
          <div>
            <img
              class="img-product"
              src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-redeem-point-img-04.jpg"
            />
            <div class="progress s">
              <div
                class="progress-bar s"
                role="progressbar"
                style="width: 50%"
                aria-valuenow="25"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <span class="name-product">บัตร starbucks card</span>
            <img
              class="iconpointproduct"
              src="https://media.ourgreen.co.th/wp-content/uploads/2021/06/loyalty-hub-bottom-navigation-01-reward-active.png"
            />
            <span class="name-price">9,000</span>
            <span class="name-time">เวลาที่เหลือ 95 วัน</span>
          </div>
        </a> -->
      </div>
      <div class="lastrow"></div>
    </body>
  </html>
</template>
<script>
import Navbar from "./navbar";
export default {
  name: "",
  components: {
    navbar: Navbar,
  },
  data() {
    return {
      //info: this.$store.state.profile,
      //rewards: [],
    };
  },
  beforeCreate() {
    console.log("REDEEM BEFORE CREATE");
    this.$store.dispatch("listRewards", { custId: localStorage.getItem("custId") });
  },

  computed: {
    info() {
      return this.$store.state.profile;
    },
    rewards() {
      return this.$store.state.rewards;
    },
  },
  mounted() {
    // console.log(this.$store.state.rewards);
  },
  methods: {
    remainDate(expireDate) {
      return Math.floor((new Date(expireDate) - new Date()) / (1000 * 60 * 60 * 24));
    },
    goto(page, index) {
      console.log(page);
      this.$router.push({
        name: page,
        params: {
            rewardIndex: index,
          }
        /*query: {
          apiKey: localStorage.getItem("apiKey"),
          custId: localStorage.getItem("custId"),
          rewardIndex: index,
        },*/
      });
    },
  },
};
</script>
<style scoped>
@import "./Css/style.css";
.container {
  margin-right: auto;
  margin-left: auto;
  position: revert;
  cursor: pointer;
  font-size: 17px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
@media (min-width: 768px) {
  .container {
    width: 750px;
  }
}
@media (min-width: 992px) {
  .container {
    width: 970px;
  }
}
@media (min-width: 1200px) {
  .container {
    width: 1170px;
  }
}
p {
    margin-top: -10px !important;
}
.row {
  margin-right: 0px !important;
  margin-left: 0px !important;
  margin-top: 20px;
      padding-top: 10px;
    padding-bottom: 10px;
}


.bg-white {
  background: #7bc79a;
  border-radius: 10px;
  width: 100%;
  position: relative;
  overflow: visible;
  top: 55px;
      box-shadow: 2px 2px #cac2c212;
}
.bg-white.s {
  background: #7bc79a;
  border-radius: 10px;
  width: 100%;
  position: relative;
  overflow: visible;
  top: 100px;
}

h1 {
  font-size: 30px;
  margin-top: 12px;
  margin-left: 12px;
  padding-left: 41px;
}

 .img-product-redeem {
    width: 90px;
    height: 90px;
    margin: .5em;
    display: block;
    float: left;
} 
.name-product {
  font-family: 'Prompt';
  color: #000000;
  margin-top: 13px;
  font-size: 19px;
}
.name-price {
      font-family: Prompt;
    color: #7bc79a;
    padding: 0 0 0 5px;
    margin-top: 3px;
    font-size: 25px;
    font-weight: 600;
}
.name-time {
  font-family: 'Prompt';
  color: #7f8285;
  margin-top: 32px;
  margin-bottom: 0px;
  font-size: 12px;
}
.iconpointproduct {
      display: block;
    margin-right: 8px;
    margin-top: 5px;
    height: 23px;
    width: 23px;
    float: left;
}
.icon-title {
  display: block;
  margin-left: 3px;
  margin-right: 2px;
  width: 40px;
  height: 40px;
  float: left;
  margin-top: 0;
}
.progress {
margin-top: 10px;
    margin-right: 5px;
    height: .5rem;
    border-radius: 0px;
}
.progress.s {
  margin-top: 8px;
  margin-right: 5px;
  height: 0.5rem;
  border-radius: 53px;
}
.progress-bar {
  background-color: #003827;
  border-radius: 53px;
}
.progress-bar.s {
  background-color: #003827;
  border-radius: 53px;
}
.lastrow {
  margin-bottom: 200px;
}
</style>
